module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.readonly) ? _c('div', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "id": _vm.id
    }
  }, [_c('input', {
    ref: "radioB",
    attrs: {
      "name": _vm.name,
      "disabled": "",
      "type": "radio",
      "required": _vm.isRequired,
      "data-conditions": _vm.options
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(_vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.savedValue.value
    }
  })]) : _c('div', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "id": _vm.id
    }
  }, [_c('input', {
    ref: "radioB",
    attrs: {
      "name": _vm.name,
      "type": "radio",
      "required": _vm.isRequired,
      "data-conditions": _vm.options
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(_vm._s(_vm.label) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eaba17d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/radio.vue
// module id = 1023
// module chunks = 0